import AccessDeniedPlaceholder from './AccessDeniedPlaceholder';
import ErrorNotFoundPlaceholder from './ErrorNotFoundPlaceholder';
import ErrorUnauthorizedPlaceholder from './ErrorUnauthorizedPlaceholder';
import ErrorUnexpectedPlaceholder from './ErrorUnexpectedPlaceholder';
import NoAssignmentsPlaceholder from './NoAssignmentsPlaceholder';
import NoCompletedGoalsPlaceholder from './NoCompletedGoalsPlaceholder';
import NoConversationMessagesPlaceholder from './NoConversationMessagesPlaceholder';
import NoConversationsPlaceholder from './NoConversationsPlaceholder';
import NoCreatedGoalsPlaceholder from './NoCreatedGoalsPlaceholder';
import NoLikedGoalsPlaceholder from './NoLikedGoalsPlaceholder';
import NoNotificationsPlaceholder from './NoNotificationsPlaceholder';
import NoProfileAboutMePlaceholder from './NoProfileAboutMePlaceholder';
import NoProfileLinksPlaceholder from './NoProfileLinksPlaceholder';
import NoStreamsPlaceholder from './NoStreamsPlaceholder';
import NoSubscribedGoalsPlaceholder from './NoSubscribedGoalsPlaceholder';
import NothingFoundPlaceholder from './NothingFoundPlaceholder';
import PlaceholderContainer from './PlaceholderContainer';
import PlaceholderHeader from './PlaceholderHeader';
import PlaceholderIcon from './PlaceholderIcon';
import PlaceholderText from './PlaceholderText';

export {
  AccessDeniedPlaceholder,
  ErrorNotFoundPlaceholder,
  ErrorUnauthorizedPlaceholder,
  ErrorUnexpectedPlaceholder,
  NoAssignmentsPlaceholder,
  NoCompletedGoalsPlaceholder,
  NoConversationMessagesPlaceholder,
  NoConversationsPlaceholder,
  NoCreatedGoalsPlaceholder,
  NoLikedGoalsPlaceholder,
  NoNotificationsPlaceholder,
  NoProfileAboutMePlaceholder,
  NoProfileLinksPlaceholder,
  NoStreamsPlaceholder,
  NoSubscribedGoalsPlaceholder,
  NothingFoundPlaceholder,
  PlaceholderContainer,
  PlaceholderHeader,
  PlaceholderIcon,
  PlaceholderText
};
